import React from 'react';
import './style.css';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import PickDayComponent from './scenes/pick-day/index';
import areIntlLocalesSupported from 'intl-locales-supported';
import EditSingleComponent from './scenes/edit-single/index';
import diagnostics from '../../../../services/diagnostics/index';
import doctors from '../../../../services/doctors/index';
import patients from '../../../../services/patients/index';
import LoadingComponent from '../../../../components/loading/index';

let DateTimeFormat;

if (areIntlLocalesSupported(["es"])) {
    DateTimeFormat = global.Intl.DateTimeFormat;
} else {
    const IntlPolyfill = require('intl');
    DateTimeFormat = IntlPolyfill.DateTimeFormat;
    require('intl/locale-data/jsonp/es');
}

export default class HomeComponent extends React.Component {
    state = {
        diagnostics: [],
        doctors: [],
        patients: [],
        loading: true
    }

    componentWillMount() {
        diagnostics.find({},(err, diagnostics) => {
            doctors.find({}, (err, doctors) => {
                patients.find({}, (err, patients) => {
                    this.setState({diagnostics: diagnostics, doctors: doctors, patients: patients, loading: false})
                })
            })
        })
    }

    addPatient = (patient) => {
        this.setState({patients: this.state.patients.concat(patient)})
    }

    render() {
        if(this.state.loading)
            return <LoadingComponent />

        return (
            <div className="Home">
                <Switch>
                    <Route path="/home/pick-day/:timestamp?/:chair?"
                        render={props =>
                            <PickDayComponent {...props}
                                format={DateTimeFormat}
                                diagnostics={this.state.diagnostics}
                                doctors={this.state.doctors}
                                patients={this.state.patients}/>}
                            />
                    <Route path='/home/edit-single/:timestamp/:chair'
                        render={(props) =>
                            <EditSingleComponent {...props} diagnostics={this.state.diagnostics}
                                doctors={this.state.doctors}
                                patients={this.state.patients}
                                user={this.props.user}
                                addPatient={this.addPatient}
                            />}/>
                    <Route render={() => <Redirect to="/home/pick-day" />} />
                </Switch>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/home/index.js